exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-image-wr.waiting > .avatar-uploader {\n  border: 1px solid #4dc45f;\n  border-radius: 3px;\n  box-shadow: 3px 2px 7px #4dc45f;\n}\n.avatar-uploader {\n  display: inline-block;\n  max-width: 200px;\n  max-height: 200px;\n}\n.avatar-uploader .ant-upload {\n  width: 100%;\n  margin-right: 0;\n  margin-bottom: 0;\n}\n.avatar-uploader .ant-upload > span.ant-upload {\n  padding: 0;\n}\n.avatar-uploader .ant-upload > span.ant-upload img {\n  width: 100%;\n  border-radius: 3px;\n  max-height: 200px;\n}\n@media only screen and (min-width: 768px) {\n  .avatar-uploader {\n    width: 100%;\n    height: 100%;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-oneOf-3-1!./node_modules/less-loader/dist/cjs.js??ref--1-oneOf-3-2!./src/components/Items/ImageUploader.less
// module id = 1327
// module chunks = 0